import React from 'react';
import {
  DialogContainer,
  DialogHeader,
  DialogTitle,
  DialogText,
  DialogButton,
} from '../shared';

interface QuitInterviewDialogProps {
  open: boolean;
  onContinue: () => void;
  onQuit: () => void;
}

const QuitInterviewDialog: React.FC<QuitInterviewDialogProps> = ({
  open,
  onContinue,
  onQuit,
}) => {
  return (
    <DialogContainer open={open}>
      <DialogHeader variant="simple" />

      <div style={{ padding: '24px' }}>
        <DialogTitle>
          Are you sure you want to quit interview?
        </DialogTitle>
        <DialogText style={{ marginBottom: '24px' }}>
          If you quit now, you will not be able to continue this interview session.
        </DialogText>

        <div style={{ display: 'flex', gap: '16px' }}>
          <DialogButton variant="secondary" onClick={onContinue} fullWidth>
            Continue Interview
          </DialogButton>
          <DialogButton variant="danger" onClick={onQuit} fullWidth>
            Quit Anyway
          </DialogButton>
        </div>
      </div>
    </DialogContainer>
  );
};

export default QuitInterviewDialog;
